import TipoOptions from "@app/types/core.types";
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { EStatusArquivo } from "@app/enums/EGuidTipoSasDocumento copy";

export const optionsSwitch: TipoOptions[] = [
  { text: 'Sim', value: true },
  { text: 'Não', value: false },
];

export const optionsSwitchNa: TipoOptions[] = [
  { text: 'Sim', value: true },
  { text: 'Não', value: false },
  { text: 'N/A', value: 'na' },
];

export const optionsAvaliacaoSasPropostaTecnica: TipoOptions[] = [
  { text: 'Verificado', value: 0 },
  { text: 'Em Revisão', value: 1 },
];

export const optionsCheckDocumentacao: TipoOptions[] = [
  { text: 'Concluída', value: 'Concluída' },
  { text: 'Em Revisão', value: 'Em Revisão' },
];

export const optionsVigenciaArquivoDocumentoOrdemCompra: TipoOptions[] = [
  { text: 'Validado', value: EStatusArquivo.VALIDADO },
  { text: 'Pendente', value: EStatusArquivo.PENDENTE },
];

export const optionsResultadoAnalise: TipoOptions[] = [
  { text: 'Apto', value: 'Apto' },
  { text: 'Apto com Ressalva', value: 'Apto com Ressalva' },
  { text: 'Informações Insuficientes', value: 'Informações Insuficientes' },
  { text: 'Inapto', value: 'Inapto' },
];

export const optionsTermoAditivo: TipoOptions[] = [
  { text: '1° TAC', value: 1 },
  { text: '2° TAC', value: 2 },
  { text: '3° TAC', value: 3 },
  { text: '4° TAC', value: 4 },
  { text: '5° TAC', value: 5 },
  { text: '6° TAC', value: 6 },
  { text: '7° TAC', value: 7 },
  { text: '8° TAC', value: 8 },
  { text: '9° TAC', value: 9 },
  { text: '10° TAC', value: 10 },
  { text: '11° TAC', value: 11 },
  { text: '12° TAC', value: 12 },
  { text: '13° TAC', value: 13 },
  { text: '14° TAC', value: 14 },
  { text: '15° TAC', value: 15 },
];


export const getByText = (options: TipoOptions[], text: string): string | number | boolean => {
  let option = options.find((option) => option.text === text);
  return option && isObjNotEmpty(option)
    ? option.text
    : '';
}

export const vtGetOptionValueByText = (options: TipoOptions[], text: string): string | number | boolean => {
  let option = options.find((option) => option.text === text);
  return option && isObjNotEmpty(option)
    ? option.value
    : '';
}

export const vtGetOptionTextByValue = (options: TipoOptions[], value: any): string | number | boolean => {
  if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') {
    throw new Error('Invalid value');
  }
  let option = options.find((option) => option.value === value);
  return option && isObjNotEmpty(option)
    ? option.text
    : '';
}

